<template>
	<div>
		<v-dialog v-model="dialog_address" no-click-animation persistent fullscreen scrollable max-width="500px" transition="dialog-bottom-transition">
	      <v-card flat style="padding-top:56px !important;" v-if="$parent.Form.addressData">
	      	<v-toolbar fixed flat class="main_toolbar">
                    <v-toolbar-side-icon @click="$parent.fn_closeDialog"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
                    <v-toolbar-title>{{$parent.Form.addressData.groupTypeId == 101 ? 'Billing Address' : 'Shipping Address'}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn round-borders outline @click="fn_checkValidations">Done</v-btn>
                </v-toolbar>
	        <!-- <v-card-title noshadow class="dialog_searchbox">
        		<v-subheader full-width>Address</v-subheader>
        	</v-card-title> -->
	        <!-- <v-divider></v-divider> -->
	        <v-card-text dialog-card-content>
	            <v-layout wrap>
	            	<v-form data-vv-scope="fields" full-width>

			            <!-- <v-layout row wrap>
			            	<span class="error--text form-item" errortxt v-if="!$parent.Form.addressData.isBillingAddress && !$parent.Form.addressData.isShippingAddress">Please select address type</span>

				            <v-flex xs6 sm6 md6 form-item sibling-form-field>
		    	               <v-checkbox class="check_box" label="Billing" v-model="$parent.Form.addressData.isBillingAddress"></v-checkbox>
		  	            	</v-flex>

			  	            <v-flex xs6 sm6 md6 form-item>
		    	               <v-checkbox class="check_box" label="Shipping" v-model="$parent.Form.addressData.isShippingAddress"></v-checkbox>
			  	            </v-flex>
			            </v-layout> -->

			            <!-- add this if you want to update country-->
			            <!-- @click="openCountries('ref_dialogAddress_country')" -->

						<template>
							<v-flex xs12 sm12 md12 form-item v-if="editName">
								<v-text-field  :label="$parent.Form.addressData.groupTypeId == 101 ? 'Biller Name' : 'Shipper Name'" placeholder=" " v-model="$parent.Form.addressData.billerShipperName"></v-text-field>
							</v-flex>

							<v-flex xs12 sm12 md12 form-item v-else>
								<v-text-field :disabled="true" :hide-details="!editName" :label="$parent.Form.addressData.groupTypeId == 101 ? 'Biller Name' : 'Shipper Name'" placeholder=" " :value="billerShipperName"></v-text-field>
								<div right-align><v-btn class="mr-0 pr-0" color="primary" flat @click="fn_editName">Edit</v-btn></div>
							</v-flex>
						</template>

			            <v-flex xs12 sm12 md12 form-item>
			               <!-- <v-text-field  label="Address" placeholder=" " v-model="$parent.Form.addressData.addressLine"></v-text-field> -->

			               <v-textarea rows="2" label="Address" placeholder=" " v-model="$parent.Form.addressData.addressLine"></v-textarea>
			            </v-flex>

			            <v-flex xs12 sm12 md12 form-item>
			               <v-text-field  label="City" placeholder=" " v-model="$parent.Form.addressData.city"></v-text-field>
			            </v-flex>

			            <v-flex xs12 sm12 md12 form-item @click="openStates('android', 'States', 'ref_dialogAddress_state')" v-if="$parent.Form.addressData.country=='India'">

			               	<v-text-field  
			               		readonly
			               		v-model="$parent.Form.addressData.state" 
			               		label="State" 
			               		placeholder=" "
			               		append-icon="arrow_drop_down"
			               		ref="ref_dialogAddress_state" 
				               	:onUpdate="updateState">
			               	</v-text-field>

			            </v-flex>

			            <v-flex xs12 sm12 md12 form-item v-else>
					        <v-combobox
					          v-model="$parent.Form.addressData.state"
					          :items="$parent.Form.addressData.otherStates"
					          label="State"
					          placeholder=" " 
					        ></v-combobox>
					    </v-flex>
						
<!-- v-validate="'verify_pincode'"  -->
			            <v-flex xs12 sm12 md12 form-item>
			               <v-text-field  
			               		label="Pincode" 
			               		placeholder=" " 
			               		type="number" 
			               		v-model="$parent.Form.addressData.pincode"
			               		v-validate="'numeric'" 
				               	:error-messages="errors.collect('fields.Pincode')" 
				               	data-vv-name="pincode">
				               			
				            </v-text-field>
			            </v-flex>

						<v-flex xs12 sm12 md12 form-item @click="openCountries('android', 'Country', 'ref_dialogAddress_country', 'address')">

							<v-text-field  
									readonly
									v-model="$parent.Form.addressData.country" 
									label="Select Country" 
									placeholder=" "
									append-icon="arrow_drop_down"
									ref="ref_dialogAddress_country" 
									:onUpdate="updateCountry">
								</v-text-field>
								
							</v-flex>

							<v-flex xs12 sm12 md12 form-item>
								<v-text-field  
									label="Telephone" 
									placeholder=" " 
									type="tel" 
									v-model="$parent.Form.addressData.phone">
								</v-text-field>
							</v-flex>

			            <v-flex xs12 sm12 md12 form-item v-if="(!$parent.Form.shippingAddress || !$parent.Form.shippingAddress.length) && $parent.Form.addressData.groupTypeId == 101 && type=='ledger'">
	    	               <v-checkbox class="check_box" label="Shipping Address (Same as billing)" v-model="$parent.Form.addressData.isSameAddress"></v-checkbox>
	  	            	</v-flex>

		            </v-form>
	            </v-layout>

	        </v-card-text>
	        <!-- <v-divider></v-divider> -->
	        <!-- <v-card-actions>
	          <v-spacer></v-spacer>
	          <v-btn color="blue darken-1" flat @click="$parent.fn_closeDialog">close</v-btn>
	          <v-btn color="blue darken-1" flat @click="fn_checkValidations">Done</v-btn>
	        </v-card-actions> -->
	      </v-card>
	    </v-dialog>
	</div>
</template>

<script>
export default{
	props:['openCountries', 'openStates', 'updateCountry', 'updateState', 'saveAddress', 'type', 'partyName'],
	data(){	
		return{
			dialog_address: false,
			editName:false,
			billerShipperName:null
		}
	},
	methods:{
		openDialogWeb: function () {	
			this.errors.clear('fields');
			this.dialog_address = true;
			this.editName = false;
			this.billerShipperName = '';
			if(this.$parent.Form.addressData && this.$parent.Form.addressData.billerShipperName){
				this.editName = true;
			}
			else{
				this.billerShipperName = this.partyName;
			}
		},
		closeDialogWeb: function () {
			this.dialog_address = false;
		},
		fn_editName: function(){
			this.editName = true;
			this.$parent.Form.addressData.billerShipperName = this.billerShipperName;
		},
		fn_checkValidations: function () {
			// let self = this;

			// let customError = false;

			// if(!this.$parent.Form.addressData.isBillingAddress && !this.$parent.Form.addressData.isShippingAddress){
			// 	customError = true;
			// }
			if(!this.$parent.Form.addressData.billerShipperName){
				this.$parent.Form.addressData.billerShipperName = '';
			}

			this.$validator.validateAll('fields').then((result) => {
				// if(result && !customError){
				if(result){
					if(this.$parent.Form.addressData.isNew && !this.$parent.Form.isCashTransaction){
						delete this.$parent.Form.addressData.isNew;
						this.fn_postAddressToMaster(()=>{
							this.saveAddress(this.$parent.Form.addressData);
						})
					}
					else{
						this.saveAddress(this.$parent.Form.addressData);
					}
				}
				else{
					let cardElement = document.querySelector('.address .v-card__text');
					let errorElement = document.querySelectorAll('.address .v-card__text .error--text')[0];
					cardElement.scrollTop = errorElement.offsetTop - 100;
				}
		    });
		},
		fn_postAddressToMaster: function(callback){
			this.postData('PartyAddress', this.$parent.Form.addressData, 
				{
					onSuccess: function(response){
						console.log(response);
						callback();
					},
					onError: function(error){
						console.log(error);
					}
				}
			)
		},
	}
}
</script>


// WEBPACK FOOTER //
// src/components/dialogs/dialog_address.vue